<div class="row">
    <div class="col-12"><h2 class="headline">Für Ihren besonderen Geschmack</h2></div>
</div>
<div class="row justify-content-center">
    <div class="col-12 col-md-6 col-lg-4 ">
        <div class="category-overview-taste"><a routerLink="/shop/lieblingstropfen-von-frauen"><img src="./assets/design/category/taste/lieblingstropfen-von-frauen.jpg" alt=""><span class="txt">Lieblingstropfen von Frauen</span></a></div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
        <div class="category-overview-taste"><a routerLink="/shop/lieblingstropfen-von-maennern"><img src="./assets/design/category/taste/lieblingstropfen-von-maennern.jpg" alt=""><span class="txt">Lieblingstropfen von Männern</span></a></div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
        <div class="category-overview-taste"><a routerLink="/shop/suess"><img src="./assets/design/category/taste/suess.jpg" alt=""><span class="txt">Süß</span></a>
        </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
        <div class="category-overview-taste"><a routerLink="/shop/klar"><img src="./assets/design/category/taste/klar.jpg" alt=""><span class="txt">Klar</span></a>
        </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
        <div class="category-overview-taste"><a routerLink="/shop/mild-und-nicht-zu-suess"><img src="./assets/design/category/taste/mild-und-nicht-zu-suess.jpg" alt=""><span class="txt">Mild und nicht zu süß</span></a></div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
        <div class="category-overview-taste"><a routerLink="/shop/hochprozentig"><img src="./assets/design/category/taste/hochprozentig.jpg" alt=""><span class="txt">Hochprozentig</span></a></div>
    </div>
</div>
